// Pharmascience — reading progress bar (topic + lesson pages).
//
// A navy bar pinned to the top of the viewport that fills as the learner
// scrolls a long topic. PRESENTATION ONLY: it reads scroll position and
// writes one CSS custom property. It never touches LearnDash completion,
// never posts, and its absence changes no behaviour.
//
// 🔴 NOT the same component as `.bnrmp-progress`. That one is COURSE
// progress (steps completed) and was deliberately removed from topic page
// headers — see the comment block in learndash/ld30/topic.php. This is
// scroll position within one page. Different meaning, different element,
// deliberately different class name so neither can be mistaken for the
// other by a later reader.
//
// The bar is emitted server-side (header.php) rather than injected here, so
// it does not appear-then-jump on slow JS, and so a `display:none` in CSS
// is enough to remove it without touching JS.

export function initReadingProgress() {
  const bar = document.querySelector('.bnrmp-readprogress__fill');
  if (!bar) return;

  let ticking = false;

  const update = () => {
    ticking = false;
    // Scrollable distance. On a page shorter than the viewport this is 0 —
    // guard it, or the division yields NaN/Infinity and the bar renders full
    // on a page with nothing to scroll.
    const max =
      document.documentElement.scrollHeight - window.innerHeight;
    const pct = max > 0 ? (window.scrollY / max) * 100 : 0;
    // Clamped: elastic/rubber-band scrolling reports negative scrollY and
    // overscroll past the end, both of which would push the fill outside
    // the track.
    const clamped = Math.max(0, Math.min(100, pct));
    // No ARIA value is written: the wrapper is aria-hidden. The scroll
    // position is already conveyed by the scrollbar itself, so announcing a
    // second live percentage would be noise, not information.
    bar.style.setProperty('--bnrmp-readprogress', clamped.toFixed(2) + '%');
  };

  const onScroll = () => {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(update);
  };

  window.addEventListener('scroll', onScroll, { passive: true });
  // Resize changes scrollHeight and innerHeight, so the ratio is stale.
  window.addEventListener('resize', onScroll, { passive: true });
  update();
}
